/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './BetaAccessRolloutRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#enroll
 */
export const ENROLL_MUTATION_FIELD_NAME = 'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_enroll';
export const ENROLL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ENROLL_MUTATION_FIELD_NAME,
  args: ['rolloutId', 'enrollType', 'needsUngating', 'shouldUpdateMultiAccounts'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.enrollRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#updateEnrollType
 */
export const UPDATE_ENROLL_TYPE_MUTATION_FIELD_NAME = 'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_updateEnrollType';
export const UPDATE_ENROLL_TYPE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ENROLL_TYPE_MUTATION_FIELD_NAME,
  args: ['request'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateEnrollTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc#leave
 */
export const LEAVE_MUTATION_FIELD_NAME = 'com_hubspot_feature_rollouts_app_rpc_BetaAccessRolloutRpc_leave';
export const LEAVE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: LEAVE_MUTATION_FIELD_NAME,
  args: ['rolloutId', 'enrollType', 'needsUngating', 'shouldUpdateMultiAccounts'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.leaveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});